// This will be the bundle for the vue components and main site styles.


 import "../css/vuestyles.scss";
// import '../fed_build/css/fonts.scss';


import Vue from 'vue'

//Vue.config.devtools = true;

import AllComps from '../master-components/BaseComponents.vue';
import Inview from 'vueinview';
import InvestmentSolutionsSection from '../systems/InvestmentSolutionsSection.vue';
import HamiltonDifferenceSection from '../systems/HamiltonDifferenceSection.vue';
import HomeCarousel from '../systems/HomeCarousel.vue';

import FilterView from '../systems/FilterView.vue';

import Subscribe from '../components/Subscribe.vue';
import DocumentFilterList from '../components/DocumentFilterList.vue';
import FundAtAGlance from '../components/FundAtAGlance.vue';

import TabbedSiteSearchResults from '../components/TabbedSiteSearchResults.vue';

const axios = require('axios');

let axiosConfig = {
  baseURL: '/api/'
};

Vue.prototype.$axios = axios.create(axiosConfig)

Vue.use(Inview);

function extractData(rootEl) {
  let data = Array.from(rootEl.querySelectorAll("li"));
  data = data.map(item => Object.assign({}, item.dataset));

  return data;

}


if (document.getElementById("app")) {
  new Vue({
    el: '#app',
    render: h => h(AllComps)
  })

}

//Vertical Scroll Widget
if (document.getElementById("investment-solutions-section")) {
  const vm = new Vue({
    el: document.querySelector("#investment-solutions-section"),
    components: { InvestmentSolutionsSection }
  });
}

//Slideshow Carousel, Article Listing
if (document.querySelector(".hamilton-carousel")) {
  const vm = new Vue({
    el: document.querySelector(".hamilton-carousel"),
    components: { HamiltonDifferenceSection }
  });
}

// Home Carousel
if (document.querySelector(".home-carousel")) {
    const vm = new Vue({
        el: document.querySelector(".home-carousel"),
        components: { HomeCarousel }
    });
}

//Filter-list - Article Listing, Team Listing
if (document.querySelector(".filter-area")) {
  const vm = new Vue({
    el: document.querySelector(".filter-area"),    // assumes one filter area per page, not multiple
    components: { FilterView }
  });

}

//Signup Widget
if (document.querySelectorAll(".subscribe-callout-area").length > 0) {

  let callouts = Array.from(document.querySelectorAll(".subscribe-callout-area"));
  callouts.forEach((callout) => {
    const vm = new Vue({
      el: callout,
      components: { Subscribe }
    });
  })

}

//Document List Widget
if (document.getElementById("document-list-widget")) {
  const vm = new Vue({
    el: document.querySelector("#document-list-widget"),
    components: { DocumentFilterList }
  });
}

//Fund at a Glance Widget
if (document.querySelectorAll(".fund-summary-widget").length > 0) {
  let callouts = Array.from(document.querySelectorAll(".fund-summary-widget"));
  callouts.forEach((callout) => {
    const vm = new Vue({
      el: callout,
      components: { FundAtAGlance }
    });
  })
}

//Search Results Page
if (document.querySelectorAll(".tabbed-site-search-results").length > 0) {
  let callouts = Array.from(document.querySelectorAll(".tabbed-site-search-results"));
  callouts.forEach((callout) => {
    const vm = new Vue({
      el: callout,
      components: { TabbedSiteSearchResults }
    });
  })
}